import {FC} from 'react'
import {Modal, Table} from 'react-bootstrap'
import {getNameByISO3, shortenLargeNumber} from '../../../../libs/misc'
import {SimulationResponse} from '../core/_models'

type Props = {show: boolean; econ: string; result: SimulationResponse; onHide: () => void}

const TwoDegreeDetailModal: FC<Props> = ({show, econ, result, onHide}) => {
  const detail = result.partners_affected.diverted_to_detail_data
  const topPartners = detail?.top_partners?.[econ] || []
  const topFlows = detail?.top_flows?.[econ] || []

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Trade diversion to {getNameByISO3(econ)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>Top partners</h6>
        <Table size='sm' bordered>
          <thead>
            <tr>
              <th>Partner</th>
              <th>Increased exports</th>
            </tr>
          </thead>
          <tbody>
            {topPartners.map(([iso3, val], i) => (
              <tr key={i}>
                <td>{getNameByISO3(iso3)}</td>
                <td>{shortenLargeNumber(val)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <h6 className='mt-4'>Top diverted flows</h6>
        <Table size='sm' bordered>
          <thead>
            <tr>
              <th>HS code</th>
              <th>Partner</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {topFlows.map(([hs, partner, val], i) => (
              <tr key={i}>
                <td>{hs}</td>
                <td>{getNameByISO3(partner)}</td>
                <td>{shortenLargeNumber(val)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}

export default TwoDegreeDetailModal
